module.exports = __webpack_public_path__ + "img/sdccwl.fd569949.png";